<template>
  <div>
    <h2 class="ViewHeading">Location Admin</h2>
    <div>
      <b-card no-body>
        <b-tabs card>
          <b-tab active>
            <template #title>
              Locations
            </template>
            <b-card-text>
              <b-card-Group>
                <b-table
                  sticky-header
                  id="locationTable"
                  :items="locationArray"
                  :fields="fields"
                  no-border-collapse
                  hover
                  show-empty
                  empty-text="You currently dont have any locations"
                  responsive
                  small
                >
                  <template v-slot:cell(Edit)="{ item }">
                    <b-button
                      variant="outline-info"
                      size="sm"
                      v-on:click="showLocationModal(item, 'Edit')"
                    >
                      <BIconPencilSquare> </BIconPencilSquare>
                    </b-button>
                  </template>
                </b-table>
                <b-row>
                  <b-col>
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      @click="showAddNewLocation()"
                    >
                      <BIconPlusSquare></BIconPlusSquare> Add New Location
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-Group>
            </b-card-text>
          </b-tab>
          <b-tab lazy>
            <template #title>
              Escalation Contacts
            </template>
            <b-card-text>
              <b-card-Group>
               <b-table
                  sticky-header
                  id="escalationTable"
                  :items="escalationArray"
                  :fields="escfields"
                  no-border-collapse
                  hover
                  show-empty
                  empty-text="You currently dont have any escalation contacts"
                  responsive
                  small
                >
                </b-table>
                </b-card-Group>
                </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>

      <!-------------------------------------------------------------------------------------------------------------------- 
-->

    <b-modal
                  ref="NewLocation"
                  id="NewLocation"
                  title="Add Location"
                  content-class="Modal"
                  header-bg-variant="light"
                  footer-bg-variant="light"
                  lazy
                  ok-only
                  hide-footer>
                  <b-card
                    border-variant="dark"
                    align="center"
                    header-bg-variant="secondary"
                    footer-tag="footer"
                  >
                    <template #header>
                      <h4 class="#">Add New Location</h4>
                    </template>
   
                    <b-card>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Address</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Address"
                            v-model="newLocation.Address"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Building Name</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Building Name"
                            v-model="newLocation.BuildingName"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Company</p>
                        </b-col>
                        <b-col sm="8">
                          <select v-model="newLocation.Company">
                            <option value="" select disabled
                              >Select Company</option
                            >
                            <option
                              v-for="(value, id) in this.companyArray"
                              :key="id"
                              v-bind:value="{ id: value.id, text: value.text }"
                              >{{ value.text }}</option
                            >
                          </select>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Country</p>
                        </b-col>
                        <b-col sm="8">

                          <select v-model="SelectedCountry">
                            <option value="" select disabled
                              >Select Country</option
                            >
                            <option
                              v-for="(value, id) in this.CountriesArray"
                              :key="id"
                              v-bind:value="{ id: value.id, text: value.text }"
                              >{{ value.text }}</option
                            >
                          </select>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Region</p>
                        </b-col>
                        <b-col sm="8">
                          <select v-model="newLocation.Region">
                            <option value="" select disabled
                              >Select Region</option
                            >
                            <option
                              v-for="(value, id) in this.RegionsArray"
                              :key="id"
                              v-bind:value="{ id: value.id, text: value.text }"
                              >{{ value.text }}</option
                            >
                          </select>
                        </b-col>
                      </b-row>
                      <hr/>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Escalation Name</p>
                        </b-col>
                        <b-col sm="8">  
                          <input
                            type="text"
                            placeholder="Escalation Name"
                            v-model="newEscalation.EscName"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Escalation Email</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Email Address"
                            v-model="newEscalation.EscEmail"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Escalation Tel</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Telephone No"
                            v-model="newEscalation.EscTele"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Seraph Protect User</p>
                        </b-col>
                        <b-col sm="8">
                          <b-form-select v-model="newEscalation.EscSeraph" :options="options2"></b-form-select>
                        
                        </b-col>
                      </b-row>
                      
                    </b-card>
                    <br />
                  </b-card>
                  <br />
                    <b-row>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="addNewLocation()"
                        >
                          Submit
                        </b-button>
                      </b-col>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="ClearNewLocationModal()"
                        >
                          Clear
                        </b-button>
                      </b-col>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="CancelNewLocationModal()"
                        >
                          Cancel
                        </b-button>
                      </b-col>
                    </b-row>


    </b-modal>
    <b-modal
                  ref="EditLocation"
                  id="EditLocation"
                  title="Edit Location"
                  content-class="Modal"
                  header-bg-variant="light"
                  lazy
                  hide-footer>
                  <b-card  border-variant="dark"
                    align="center"
                    header-bg-variant="secondary"
                    footer-tag="footer">
                    <template #header>
                      <h4 class="#">Edit Location</h4>
                    </template>
                    <br />
                    <b-card
                    border-variant="dark"
                    align="center"
                    header-bg-variant="secondary"
                    footer-tag="footer"
                  >
                    <b-card>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Address</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Address"
                            v-model="LocationPassed.Address"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Building Name</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Building Name"
                            v-model="LocationPassed.Location"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Company</p>
                        </b-col>
                        <b-col sm="8">
                          {{ LocationPassed.Company }}
                          <!-- <select v-model="LocationPassed.Company">
                            <option value="" select disabled
                              >Select Company</option
                            >
                            <option
                              v-for="(value, id) in this.companyArray"
                              :key="id"
                              v-bind:value="{ id: value.id, text: value.text }"
                              >{{ value.text }}</option
                            >
                          </select> -->
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Country</p>
                        </b-col>
                        <b-col sm="8">
                          {{ LocationPassed.Country }}

                          <!-- <select v-model="LocationPassed.Country">
                            <option value="" select disabled
                              >Select Country</option
                            >
                            <option
                              v-for="(value, id) in this.CountriesArray"
                              :key="id"
                              v-bind:value="{ id: value.id, text: value.text }"
                              >{{ value.text }}</option
                            >
                          </select> -->
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Region</p>
                        </b-col>
                        <b-col sm="8">
                          {{ LocationPassed.Region }}
                          <!-- <select v-model="LocationPassed.Region">
                            <option value="" select disabled
                              >Select Region</option
                            >
                            <option
                              v-for="(value, id) in this.RegionsArray"
                              :key="id"
                              v-bind:value="{ id: value.id, text: value.text }"
                              >{{ value.text }}</option
                            >
                          </select> -->
                        </b-col>
                      </b-row>
                      <hr/>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Escalation Name</p>
                        </b-col>
                        <b-col sm="8">  
                          <input
                            type="text"
                            placeholder="Escalation Name"
                            v-model="EscalationPassed.EscName"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Escalation Email</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Email Address"
                            v-model="EscalationPassed.EscEmail"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Escalation Tel</p>
                        </b-col>
                        <b-col sm="8">
                          <input
                            type="text"
                            placeholder="Telephone No"
                            v-model="EscalationPassed.EscTele"
                            required
                            @focus="modal = false"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <p id="FormText">Seraph Protect User</p>
                        </b-col>
                        <b-col sm="8">
                          <b-form-select v-model="this.EscalationPassed.EscSeraph" :options="options2"></b-form-select>
                        </b-col>
                      </b-row>
                      
                    </b-card>
                    <br/>
                    </b-card>
                    <br/>
                    <b-row>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="EditLocation()"
                        >
                          Submit
                        </b-button>
                      </b-col>
                       <b-col>
                  <!-- <b-button
                          variant="outline-info"
                          v-on:click="ClearEditLocationModal()"
                        >
                          Clear
                        </b-button>  -->
                      </b-col>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="CancelEditLocationModal()"
                        >
                          Cancel
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card>
    </b-modal>
    <!-- <b-modal
                  ref="DeleteLocation"
                  id="DeleteLocation"
                  title="Delete Location"
                  content-class="Modal"
                  header-bg-variant="light"
                  footer-bg-variant="light"
                  lazy
                  ok-only
                  hide-footer>
                  <b-card>
                    This is to delete a Location
                  </b-card>
                  {{ LocationPassed }}
                  <br />
                    <b-row>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="DeleteLocation()"
                        >
                          Submit
                        </b-button>
                      </b-col>
                      <b-col>
                      </b-col>
                      <b-col>
                        <b-button
                          variant="outline-info"
                          v-on:click="CancelDeleteLocationModal()"
                        >
                          Cancel
                        </b-button>
                      </b-col>
                    </b-row>


    </b-modal> -->

      <!-- <b-modal
        ref="EditCompany"
        id="EditCompany"
        hide-footer
        title="Company Lookup Form"
        content-class="Modal"
      >
        <div>
          <h3>Edit a Company</h3>

          <select v-model="companytoEdit">
            <option value="" select disabled>Select Location</option>
            <option
              v-for="(value, id) in this.companyArray"
              :key="id"
              v-bind:value="{
                id: value.ID,
                CompanyName: value.CompanyName,
                Status: value.Status,
                BuildingName: value.BuildingName,
                EscalationName: value.EscalationName,
                EscalationEmail: value.EscalationEmail,
                EscalationPhone: value.EscalationPhone,
                SubscriptionStatus: value.SubsciptionStatus,
                SubscriptionRate: value.SubscriptionRate,
              }"
              >{{
                value.CompanyName +
                  " - " +
                  value.BuildingName +
                  " - " +
                  value.Status
              }}</option
            >
          </select>
          <br />
          <button id="button" class="button" v-on:click="goToEditCompany()">
            Submit
          </button>
          <button class="button" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal> -->
<!-- 
      <b-modal
        ref="RemoveCompany"
        id="RemoveCompany"
        hide-footer
        title="Company Lookup Form"
        content-class="Modal"
      >
        <div>
          <h3>Deactivate a Company</h3>

          <select v-model="companytoDelete">
            <option value="" select disabled>Select Location</option>
            <option
              v-for="(value, id) in this.companyToDeleteList"
              :key="id"
              v-bind:value="{
                id: value.id,
                CompanyName: value.CompanyName,
                Status: value.Status,
                BuildingName: value.BuildingName,
                EscalationName: value.EscalationName,
                EscalationEmail: value.EscalationEmail,
                EscalationPhone: value.EscalationPhone,
                SubscriptionStatus: value.SubsciptionStatus,
                SubscriptionRate: value.SubscriptionRate,
              }"
              >{{
                value.CompanyName +
                  " - " +
                  value.BuildingName +
                  " - " +
                  value.Status
              }}</option
            >
          </select>
          <br />
          <button id="button" class="button" v-on:click="goToRemoveCompany()">
            Submit
          </button>
          <button class="button" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  BIconPencilSquare,
  // BIconXSquare,
  BIconPlusSquare,
  // BIconCheckSquare,
} from "bootstrap-vue";
export default {
  components: {
    BIconPencilSquare,
    // BIconXSquare,
    BIconPlusSquare,
    // BIconCheckSquare,
  },
  methods: {
    showAddNewLocation() {
      (this.newLocation = {
        Address: "",
        BuildingName: "",
        Region: "",
        Country: "",
        Company: "",
      }),
        (this.SelectedCompany = "");
      this.SelectedCountry = "";
      this.SelectedRegion = "";
      this.locationList = "";
      this.newEscalation = {
        Location: "",
        EscName: "",
        EscEmail: "",
        EscTele: "",
        EscSeraph: ""
      }
      this.$refs["NewLocation"].show();
    },
     addNewLocation() {
      if (this.newLocation.Address == "" || this.newLocation.BuildingName == ""
        || this.newLocation.Region == "" || this.SelectedCountry == "" ||
        this.newLocation.Company == ""
      ){
        alert ("Please ensure all Building fields are completed")
      }
      else if (this.newEscalation.EscName == "" || this.newEscalation.EscEmail == "" || this.newEscalation.EscTele == "" || this.newEscalation.EscSeraph == null){
        alert ("Please ensure Escalation fields are completed, all locations are required to have an escalation contact")
      }
      else if(this.emailIsValid(this.newEscalation.EscEmail) == false){
        alert("Please check email address format")
      }
      else{

      let LookUpURLNewLoc =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersNewLoc = this.$apikeyPost;
      let LookUpRequestNewLoc = {
        RequestType: "Location",
        Action: "Create",
        DataDict: [
          {
            Address: this.newLocation.Address,
            Location: this.newLocation.BuildingName,
            EscalationName: this.newLocation.EscName,
            EscalationEmail: this.newLocation.EscEmail,
            EscalationTel: this.newLocation.EscTele,
            CountryID: this.SelectedCountry.id,
            RegionID: this.newLocation.Region.id,
            Company: this.newLocation.Company.id,
            ParentCompany: this.newLocation.Company.text
          },
        ],
      };
      axios
        .post(LookUpURLNewLoc, LookUpRequestNewLoc, LookUpHeadersNewLoc)
        .then((response) => {
          response;
          alert("Location has been added");
          this.newEscalation.Location = this.newLocation.BuildingName
          this.AddEscalation();
          this.CancelNewLocationModal();
        });
      }
    },

    AddEscalation(){
      let LookUpURLNewEsc =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersNewEsc = this.$apikeyPost;
      let LookUpRequestNewEsc = {
        RequestType: "Location",
        Action: "Escalation",
        DataDict: [
          {
            Location: this.newEscalation.Location,
            EscName: this.newEscalation.EscName,
            EscEmail: this.newEscalation.EscEmail,
            EscTele: this.newEscalation.EscTele,
            EscSeraph: this.newEscalation.EscSeraph,
            Status: "Active"
          },
        ],
      };
      axios
        .post(LookUpURLNewEsc, LookUpRequestNewEsc, LookUpHeadersNewEsc)
        .then((response) => {
          response;
        });
    },

    LookupAllEscalation(location){
      let Locationforlookup = location

      let LookUpUrlEscalation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersEscalation = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "EscalationContactAll",
      RequestVariable: Locationforlookup,
    };
    axios
      .post(
        LookUpUrlEscalation,
        this.LookUpRequest,
        LookUpHeadersEscalation
      )
      .then((response) => {
 
        let EscalationData = response.data.Values

        for(let i=0;i<EscalationData.length;i++){
          this.escalationArray.push({
            Location:EscalationData[i][1],
            Address:EscalationData[i][2],
            Contact: EscalationData[i][3],
            Email:EscalationData[i][4],
            Tel: EscalationData[i][5],
            Status: EscalationData[i][7]
          })
        }
  });
    },

    LookupEscalation(location){
      let Locationforlookup = location

      let LookUpUrlEscalation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersEscalation = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "EscalationContact",
      RequestVariable: Locationforlookup,
    };
    axios
      .post(
        LookUpUrlEscalation,
        this.LookUpRequest,
        LookUpHeadersEscalation
      )
      .then((response) => {

        let EscalationData = response.data.Values
        this.EscalationPassed = 
        {
        Location: EscalationData[0][0],
        EscName: EscalationData[0][1],
        EscEmail: EscalationData[0][2],
        EscTele: EscalationData[0][3],
        EscSeraph: EscalationData[0][4]
        }

  });
    },

    CancelNewLocationModal() {
      this.$refs["NewLocation"].hide();
      this.ClearNewLocationModal();
    },
    ClearNewLocationModal() {
      this.newLocation = {
        Address: "",
        BuildingName: "",
        Region: "",
        Country: "",
        Company: "",
      }
      this.newEscalation = {
        Location: "",
        EscName: "",
        EscEmail: "",
        EscTele: "",
        EscSeraph: ""
      }
      this.SelectedCompany= "",
      this.SelectedCountry= "",
      this.SelectedRegion= "",
      this.RegionsList = [],
      this.RegionsArray = []
      this.RefreshTable();
    },
    EditLocation(){
      
      let LookUpURLEdit =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersEdit = this.$apikeyPost;
      let LookUpRequestEdit = {
        RequestType: "Location",
        Action: "Edit",
        DataDict: [
          {
            Address: this.LocationPassed.Address,
            Location: this.LocationPassed.Location,
            ID: this.LocationPassed.ID
          },
        ],
      };
      axios
        .post(LookUpURLEdit, LookUpRequestEdit, LookUpHeadersEdit)
        .then((response) => {
          response;
        });
      this.EditEscalation()
      alert("Edit Successful")
      this.CancelEditLocationModal()
    },
    
    EditEscalation(){
      let LookUpURLEscEdit =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersEscEdit = this.$apikeyPost;
      let LookUpRequestEscEdit = {
        RequestType: "Location",
        Action: "EditEscalation",
        DataDict: [
          {
            Location: this.EscalationPassed.Location,
            EscName: this.EscalationPassed.EscName,
            EscEmail: this.EscalationPassed.EscEmail,
            EscTele: this.EscalationPassed.EscTele,
            EscSeraph: this.EscalationPassed.EscSeraph,
          },
        ],
      };
      axios
        .post(LookUpURLEscEdit, LookUpRequestEscEdit, LookUpHeadersEscEdit)
        .then((response) => {
          response;
        });
    },
    emailIsValid(email) {
        this.ValidMail = /\S+@\S+\.\S+/.test(email);
        return this.ValidMail
      },

    CancelEditLocationModal(){
      this.LocationPassed = "",
      this.EscalationPassed = ""
      this.editLocation = {
        Address: "",
        BuildingName: "",
        Region: "",
        Country: "",
        Company: "",
      },
      this.editEscalation = {
        Location: "",
        EscName: "",
        EscEmail: "",
        EscTele: "",
        EscSeraph: ""
      }
      this.$refs["EditLocation"].hide();
    },
  
    RefreshTable(){
      this.locationList = ""
      this.locationArray = []
      let LookUpUrlExistingLocation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersExistingLocation = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ParentCompanyLocations",
      RequestVariable: this.ParentCompany,
    };
    axios
      .post(
        LookUpUrlExistingLocation,
        this.LookUpRequest,
        LookUpHeadersExistingLocation
      )
      .then((response) => {
        this.locationList = response.data.Values;

        for (let i = 0; i < this.locationList.length; i++) {
          var QuoteStr4 = this.locationList[i][0];
          this.locationArray.push({
            ID: QuoteStr4,
            Address: this.locationList[i][1],
            Location: this.locationList[i][2],
            Country: this.locationList[i][3],
            Region: this.locationList[i][4],
            Company: this.locationList[i][5],
          });
        }
      });

    },
    // DeleteLocation(){
    //   alert("function to delete a location")
    // },
    // CancelDeleteLocationModal(){
    //   this.$refs["DeleteLocation"].hide();
    // },
      
    showLocationModal(item,Action){
      this.LocationPassed = item
      if (Action == "Edit"){
        this.$refs["EditLocation"].show(this.LocationPassed);
        this.LookupEscalation(item.ID)
      }
      // if (Action == "Delete"){
      //   this.$refs["DeleteLocation"].show(this.LocationPassed);
      // }
      // if (Action == "Active"){
      //   alert("option to activate")
      // }
    },

    regionGenerate() {
      if (this.SelectedCountry == ""){
        return;
      }
      else{
      this.RegionsList = [];
      this.RegionsArray = [];
      let LookUpUrlRegion =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/lookup";
      let LookUpHeadersRegion = this.$apikeyPost;
      let LookUpRequestRegion = {
        RequestType: "RegionByCountry",
        CountryID: this.SelectedCountry.text,
      };
      axios
        .post(LookUpUrlRegion, LookUpRequestRegion, LookUpHeadersRegion)
        .then((response) => {
          response;
          this.RegionsList = response.data.Values;
          for (let i = 0; i < this.RegionsList.length; i++) {
            var QuoteStr4 = this.RegionsList[i][0];
            this.RegionsArray.push({
              id: QuoteStr4,
              text: this.RegionsList[i][1],
            });
          }
        });
      }
    },

    // btnCooldown: function() {
    //   let buttonid = "button";
    //   const button = document.querySelector("#" + buttonid + "");
    //   if (this.buttonCooldown == true) {
    //     const disableButton = () => {
    //       button.disabled = true;
    //     };
    //     button.addEventListener("click", disableButton);
    //   } else if (this.buttonCooldown == false) {
    //     button.disabled = false;
    //   }
    // },

    // showModal(Modal) {
    //   this.DivID = "";
    //   this.$refs[Modal].show();
    // },
    // hideModal(Modal) {
    //   this.$refs[Modal].hide();
    // },
    // resetForm() {
    //   this.$refs["AddCompanyForm"].hide();

    //   this.newCompany = {
    //     CompanyName: "",
    //     Address: "",
    //     ContactName: "",
    //     ContactEmail: "",
    //     CompanyTele: "",
    //     SubRate: "",
    //   };
    //   let LookUpUrlExistingCompany =
    //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //     this.$environment +
    //     "/sulookups";
    //   let LookUpHeadersExistingCompany = this.$apikeyPost;
    //   this.LookUpRequest = { RequestType: "Company", RequestVariable: "" };
    //   axios
    //     .post(
    //       LookUpUrlExistingCompany,
    //       this.LookUpRequest,
    //       LookUpHeadersExistingCompany
    //     )
    //     .then((response) => {
    //       this.companyList = response.data.Values;

    //       for (let i = 0; i < this.companyList.length; i++) {
    //         this.companyArray.push({
    //           CompanyName: this.companyList[i][0],
    //           Status: this.companyList[i][1],
    //           BuildingName: this.companyList[i][2],
    //           EscalationName: this.companyList[i][3],
    //           EscalationEmail: this.companyList[i][4],
    //           EscalationPhone: this.companyList[i][5],
    //           SubsciptionStatus: this.companyList[i][6],
    //           SubscriptionRate: this.companyList[i][7],
    //           ID: this.companyList[i][8],
    //         });
    //       }

    //       this.companyToDeleteList = this.companyArray;
    //     });
    // },


    // goToEditCompany() {
    //   this.hideModal("EditCompany");
    //   this.editedCompany = this.companytoEdit;
    //   this.selectedSearch = "EditCompany";
    // },
    // goToRemoveCompany() {
    //   this.hideModal("RemoveCompany");
    //   this.deletedCompany = this.companytoDelete;
    //   this.selectedSearch = "RemoveCompany";
    // },

    // editCompany() {
    //   this.buttonCooldown = true;

    //   let LookUpURLEditCompany =
    //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //     this.$environment +
    //     "/superuser";
    //   let LookUpHeadersEditCompany = this.$apikeyPost;
    //   let LookUpRequestEditCompany = {
    //     RequestType: "Company",
    //     Action: "Edit",
    //     DataDict: [
    //       {
    //         CompanyName: this.editedCompany.CompanyName,
    //         CompanyAddress: this.editedCompany.BuildingName,
    //         CompanyContact: this.editedCompany.EscalationName,
    //         CompanyEmail: this.editedCompany.EscalationEmail,
    //         CompanyTel: this.editedCompany.EscalationPhone,
    //         SubscriptionRate: this.editedCompany.SubscriptionRate,
    //         SubscriptionStatus: this.editedCompany.SubscriptionStatus,
    //         CompanyID: this.editedCompany.id,
    //       },
    //     ],
    //   };
    //   axios
    //     .post(
    //       LookUpURLEditCompany,
    //       LookUpRequestEditCompany,
    //       LookUpHeadersEditCompany
    //     )
    //     .then((response) => {
    //       response;
    //       this.buttonCooldown = false;

    //       alert("Company has been edited");
    //       this.resetForm();
    //     });
    // },

    // removeCompany() {
    //   this.buttonCooldown = true;

    //   let LookUpURLDeleteCompany =
    //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //     this.$environment +
    //     "/superuser";
    //   let LookUpHeadersDeleteCompany = this.$apikeyPost;
    //   let LookUpRequestDeleteCompany = {
    //     RequestType: "Company",
    //     Action: "Delete",
    //     DataDict: [{ CompanyName: this.deletedCompany.CompanyName }],
    //   };
    //   axios
    //     .post(
    //       LookUpURLDeleteCompany,
    //       LookUpRequestDeleteCompany,
    //       LookUpHeadersDeleteCompany
    //     )
    //     .then((response) => {
    //       response;
    //       this.buttonCooldown = false;

    //       alert("Company has been Deactivated");
    //       this.resetForm();
    //     });
    // },

    /* existing Methods */

   // HistorySubmit() {
      // let current = new Date();
      // let HistoryDate =
      //   current.getFullYear() +
      //   "-" +
      //   (current.getMonth() + 1) +
      //   "-" +
      //   current.getDate();
      // let HistoryTime =
      //   current.getHours() +
      //   ":" +
      //   current.getMinutes({ minimumIntegerDigits: 2 }) +
      //   ":" +
      //   current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });

      // let LookUpURLHist =
      //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      //   this.$environment +
      //   "/adminhistory";
      // let LookUpHeadersHist = this.$apikeyPost;
      // this.LookUpRequest = {
      //   UserURN: this.UserURN,
      //   HistoryDate: HistoryDate,
      //   HistoryTime: HistoryTime,
      //   HistoryNote: this.HistoryNote,
      //   ProfilePortal: this.UserProfile,
      // };

    //   axios
    //     .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
    //     .then((response) => {
    //       response;
    //     });
    // },
  },

  mounted() {
    let UserAccessGroup = this.$ProfilePortal;
    if (UserAccessGroup == null) {
      this.$router.push("/");
    }

    let LookUpUrlExistingLocation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersExistingLocation = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ParentCompanyLocations",
      RequestVariable: this.ParentCompany,
    };
    axios
      .post(
        LookUpUrlExistingLocation,
        this.LookUpRequest,
        LookUpHeadersExistingLocation
      )
      .then((response) => {
        this.locationList = response.data.Values;

        for (let i = 0; i < this.locationList.length; i++) {
          var QuoteStr4 = this.locationList[i][0];
          this.locationArray.push({
            ID: QuoteStr4,
            Address: this.locationList[i][1],
            Location: this.locationList[i][2],
            Country: this.locationList[i][3],
            Region: this.locationList[i][4],
            Company: this.locationList[i][5],
          });
        }
      });
    // let LookUpUrlCompany =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/lookup";
    // let LookUpHeadersCompany = this.$apikeyPost;
    // this.LookUpRequest = { RequestType: "Company" };
    // axios
    //   .post(LookUpUrlCompany, this.LookUpRequest, LookUpHeadersCompany)
    //   .then((response) => {
    //     this.companylist = response.data.Values;
    //     for (let i = 0; i < this.companylist.length; i++) {
    //       var QuoteStr4 = this.companylist[i][0];
    //       this.companyArray.push({
    //         id: QuoteStr4,
    //         text: this.companylist[i][1],
    //       });
    //     }
    //   });

    let LookUpUrlExistingCompany =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersExistingCompany = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ParentChildCompanies",
      RequestVariable: this.ParentCompany,
    };
    axios
      .post(
        LookUpUrlExistingCompany,
        this.LookUpRequest,
        LookUpHeadersExistingCompany
      )
      .then((response) => {
        this.companyList = response.data.Values;

        for (let i = 0; i < this.companyList.length; i++) {
          this.companyArray.push({
            text: this.companyList[i][0],
            id: this.companyList[i][8],
          });
        }
        this.companyToDeleteList = this.companyArray;
      });

    /* Existing Look Ups */

    // let LookUpUrl3 =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/lookup";
    // let LookUpHeaders3 = this.$apikeyPost;
    // this.LookUpRequest3 = { RequestType: "BMULocation", UserURN: this.UserURN };
    // axios
    //   .post(LookUpUrl3, this.LookUpRequest3, LookUpHeaders3)
    //   .then((response) => {
    //     this.locationslist = response.data.Values;
    //     for (let i = 0; i < this.locationslist.length; i++) {
    //       var QuoteStr4 = this.locationslist[i][0];
    //       this.locationsArray.push({
    //         id: QuoteStr4,
    //         location: this.locationslist[i][2],
    //         address: this.locationslist[i][1],
    //       });
    //     }
    //   });

    let LookUpUrlLocation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeadersLocation = this.$apikeyPost;
    this.LookUpRequestLocation = {
      RequestType: "BMULocation",
      UserURN: this.UserURN,
    };
    axios
      .post(
        LookUpUrlLocation,
        this.LookUpRequestLocation,
        LookUpHeadersLocation
      )
      .then((response) => {
        this.locations = response.data.Values;
      });
    let LookUpUrlCountry =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersCountry = this.$apikeyPost;
    let LookUpRequestCountry = { RequestType: "CountryAll" };
    axios
      .post(LookUpUrlCountry, LookUpRequestCountry, LookUpHeadersCountry)
      .then((response) => {
        response;
        this.CountriesList = response.data.Values;
        for (let i = 0; i < this.CountriesList.length; i++) {
          var QuoteStr4 = this.CountriesList[i][0];
          this.CountriesArray.push({
            id: QuoteStr4,
            text: this.CountriesList[i][1],
          });
        }
      });

      this.LookupAllEscalation(this.ParentCompany)

    // let LookUpUrlRegion =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/lookup";
    // let LookUpHeadersRegion = this.$apikeyPost;
    // let LookUpRequestRegion = {
    //   RequestType: "RegionByCountry",
    //   CountryID: "5",
    // };
    // axios
    //   .post(LookUpUrlRegion, LookUpRequestRegion, LookUpHeadersRegion)
    //   .then((response) => {
    //     response;
    //     this.RegionsList = response.data.Values;
    //     for (let i = 0; i < this.RegionsList.length; i++) {
    //       var QuoteStr4 = this.RegionsList[i][0];
    //       this.RegionsArray.push({
    //         id: QuoteStr4,
    //         text: this.RegionsList[i][1],
    //       });
    //     }
    //   });
  },

  data() {
    return {
      ParentCompany: localStorage.getItem("ParentCompany"),
      newLocation: {
        Address: "",
        BuildingName: "",
        Region: "",
        Country: "",
        Company: "",
      },
      editLocation:{
        Address: "",
        BuildingName: "",
        Region: "",
        Country: "",
        Company: "",
      },
      newEscalation: {
        Location: "",
        EscName: "",
        EscEmail: "",
        EscTele: "",
        EscSeraph: ""
      },
      editEscalation: {
        Location: "",
        EscName: "",
        EscEmail: "",
        EscTele: "",
        EscSeraph: ""
      },
      SelectedCompany: "",
      SelectedCountry: "",
      SelectedRegion: "",
      locationList: "",

      // locationArray: [],
      DivID: "",
      fName: "",
      lName: "",
      locationsArray: [],
      clCompany: this.$Company,
      clDept: "",
      clLocation: "",
      clEmail: "",
      clURN: "",
      locAddress: "",
      locTele: "",
      locEscEmail: "",
      locEscName: "",
      locFloor: "",
      locBuildingName: "",
      locArea: "",
      locations: "",
      location: "",
      filteredlocations: "",
      editLocAddress: "",
      editLocBuildingName: "",
      editLocArea: "",
      editLocEscName: "",
      editLocEscEmail: "",
      editLocEscTele: "",
      contactLocation: this.$Location,
      DeviceRequestNo: "",
      userName: this.$FullName,
      BMULocationRemove: "",
      UserURN: this.$UserURN,
      CountriesArray: [],
      RegionsArray: [],
      CountriesList: [],
      RegionsList: [],
      messageforNewLocationEmail: "",
      selectedSearch: "",
      UserProfile: this.$ProfilePortal,
      companyArray: [],
      companyList: [],
      ValidMail: null,
      options2: [{ value: null, text: 'Please select an option' },
                            { value: 'true', text: 'True' },
                            { value: 'false', text: 'False' }],

      // compTele: "",
      // compEmail: "",
      // compContactName: "",
      // compAddress: "",
      // compName: "",
      // compSubRate: "",
      // companytoEdit: "",
      // companyToDeleteList: [],
      // companytoDelete: "",
      // deletedCompany: "",
      // buttonCooldown: false,

      insFName: "",
      insLName: "",
      insEmail: "",
      insCompany: localStorage.getItem("Company"),
      insURN: "",

      locRegion: [],
      editLocCountry: "",
      selectedAction: "",
      HistoryNote: "",

      deviceArray: [],
      SearchDeviceID: "",
      DeactID: "",
      DeactBuilding: "",
      DeactVersion: "N/A",
      DeactCurrentStatus: "",
      DeactPosition: "",
      DeactFeed: "",
      DeactFloor: "",
      DeactReturn: "",
      Suspendeddevicelist: [],
      SuspendeddeviceArray: [],
      deactInsURN: "",
      deactInsFName: "",
      deactInsLName: "",
      deactInsEmail: "",
      deactInsStatus: "",
      ClientList: [],
      ClientListArray: [],
      clientSelection: "",
      InstallerList: [],
      InstallerListArray: [],
      installerSelection: "",
      insPassword: "",
      nickname: "",
      subGroupLocationToSearch: "",
      deviceSubgroup: "",
      subgroupListArray: "",
      editSubgroupName: "",
      newCompany: {
        CompanyName: "",
        Address: "",
        ContactName: "",
        ContactEmail: "",
        CompanyTele: "",
        SubRate: "",
      },

      clientitems: [],
      fields: [
        { key: "Location", variant: "primary" },
        { key: "Address" },
        { key: "Region" },
        { key: "Country" },
        { key: "Company" },
        // { key: "ID" },
        { key: "Edit" },
        // { key: "Action" },
      ],
       escfields: [
        { key: "Location", variant: "primary" },
        { key: "Address" },
        { key: "Contact" },
        { key: "Email" },
        { key: "Tel" },
        {key: "Status"}
      ],
      escalationArray: [],
      clientData: "",
      clientAction: "",
      options: [],
      locationArray: [],
      selected: "",
      clearUserData: [],

      // Just to stop the stupid errors

      deactInsUsername: "",
      InsUsername: "",
      InsLName: "",
      InsFName: "",
      AccessGroupArray: [],
      LocationPassed: "",
      EscalationPassed: {
        Location: "",
        EscName: "",
        EscEmail: "",
        EscTele: "",
        EscSeraph: ""

      }
    };
  },

  watch: {
    SelectedCountry() {
      this.regionGenerate();
    },
    // buttonCooldown() {
    //   this.btnCooldown();
    // },
  },
};
</script>

<style scoped></style>
